import {message} from '@common/i18n/message';
import {MessageDescriptor} from '@common/i18n/message-descriptor';

export interface BusinessCardStyle {
  id: string;
  label: MessageDescriptor;
  industry: MessageDescriptor;
  headerBg: string;
  textColor: string;
  subTextColor: string;
  accentColor: string;
  buttonBg: string;
  buttonTextColor: string;
}

export const BusinessCardStyles: BusinessCardStyle[] = [
  {
    id: 'corporate-navy',
    label: message('Corporate Navy'),
    industry: message('Finance, Law, Consulting'),
    headerBg: '#0b1120',
    textColor: '#ffffff',
    subTextColor: 'rgba(255,255,255,0.7)',
    accentColor: '#d4af37',
    buttonBg: '#0b1120',
    buttonTextColor: '#ffffff',
  },
  {
    id: 'creative-studio',
    label: message('Creative Studio'),
    industry: message('Agency, Design, Marketing'),
    headerBg: 'linear-gradient(135deg, #7c3aed, #ec4899)',
    textColor: '#ffffff',
    subTextColor: 'rgba(255,255,255,0.8)',
    accentColor: '#ec4899',
    buttonBg: '#7c3aed',
    buttonTextColor: '#ffffff',
  },
  {
    id: 'medical-clean',
    label: message('Medical Clean'),
    industry: message('Healthcare, Wellness, Clinics'),
    headerBg: '#0e7490',
    textColor: '#ffffff',
    subTextColor: 'rgba(255,255,255,0.75)',
    accentColor: '#22d3ee',
    buttonBg: '#0e7490',
    buttonTextColor: '#ffffff',
  },
  {
    id: 'real-estate-gold',
    label: message('Real Estate Gold'),
    industry: message('Real Estate, Luxury Retail'),
    headerBg: '#1c1c1c',
    textColor: '#ffffff',
    subTextColor: 'rgba(255,255,255,0.7)',
    accentColor: '#c9a227',
    buttonBg: '#1c1c1c',
    buttonTextColor: '#c9a227',
  },
  {
    id: 'tech-gradient',
    label: message('Tech Gradient'),
    industry: message('Startups, SaaS, IT'),
    headerBg: 'linear-gradient(135deg, #4f46e5, #06b6d4)',
    textColor: '#ffffff',
    subTextColor: 'rgba(255,255,255,0.8)',
    accentColor: '#06b6d4',
    buttonBg: '#4f46e5',
    buttonTextColor: '#ffffff',
  },
  {
    id: 'minimal-mono',
    label: message('Minimal Mono'),
    industry: message('Consultants, Freelancers'),
    headerBg: '#ffffff',
    textColor: '#111111',
    subTextColor: '#555555',
    accentColor: '#111111',
    buttonBg: '#111111',
    buttonTextColor: '#ffffff',
  },
  {
    id: 'hospitality-warm',
    label: message('Warm Hospitality'),
    industry: message('Restaurants, Hotels, Events'),
    headerBg: '#7c2d12',
    textColor: '#fff7ed',
    subTextColor: 'rgba(255,247,237,0.75)',
    accentColor: '#fb923c',
    buttonBg: '#7c2d12',
    buttonTextColor: '#fff7ed',
  },
  {
    id: 'education-academic',
    label: message('Academic'),
    industry: message('Education, Coaching, NGOs'),
    headerBg: '#1e3a5f',
    textColor: '#ffffff',
    subTextColor: 'rgba(255,255,255,0.7)',
    accentColor: '#8ecae6',
    buttonBg: '#1e3a5f',
    buttonTextColor: '#ffffff',
  },
];

export const DefaultBusinessCardStyleId = 'corporate-navy';

export function getBusinessCardStyle(id?: string): BusinessCardStyle {
  return (
    BusinessCardStyles.find(s => s.id === id) ||
    BusinessCardStyles.find(s => s.id === DefaultBusinessCardStyleId)!
  );
}
